/**
 *@description
 * Pipe for piping
 * methods
 * @param {any} args
 * @function
 */
export const pipeFns = (...args) => data =>
  args.reduce((acc, fn) => {
    return fn.call(null, ...data);
  }, data);



// WEBPACK FOOTER //
// ./src/app/utils/pipe-fns.ts